import { snapshotToObjects } from 'util/firestore';
import {firebase, db} from 'util/auth';
import moment from 'moment';
import * as rp from 'request-promise'
import { CLASS_DELETED } from 'store/reducers/instructorReducer'
import {DELETE_SERVICE, IN_PROGRESS, ADD_SERVICE, UPDATE_SERVICE, SET_CONNECTED_ACCOUNTS, SET_ZOOM_CONNECTED, ADD_SCHEDULED_CLASS, ADD_SCHEDULED_CLASSES, UPDATE_SCHEDULED_CLASS} from 'store/reducers/schedulingReducer'
import { apiRequest } from 'util/api/util';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const deleteClass = (classObject) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        const state = getState();

        const firestore = getFirestore();

        const platformId = classObject.platformID
        
        return new Promise(async (resolve, reject) => {
            
            try {
                await firestore.collection("classes").doc(platformId).update({
                    deleted: true
                })
                await deleteZoomMeetingIfNeeded(classObject)
                resolve("success")
                dispatch({type: CLASS_DELETED, classId: platformId})
                
            } catch (err) {
                reject(`Unable to delete class: ${err}`)
            }
        })

        
        // const userId = state.user.userData.platformID;
        // if (userId == null) {
        //     console.log("couldn't find it...")
        //     return;
        // }
        // const firestore = getFirestore();
        // console.log("fetching classes")
        // return firestore.collection("classes").where("deleted", "==", false).where("instructor_id", "==", userId).where("start_time", ">=", moment().unix()).get()
        //     .then(snapshot => {
        //         const classes = snapshotToObjects(snapshot);
        //         console.log("got some classes")
        //         console.log(classes.length)
        //         dispatch({type: 'SET_SCHEDULED_CLASSES', classes: classes})
        //         return classes
        //     })
    }
}

export const uploadInProgress = (inProgress) => {
    return dispatch => {
        return dispatch({type: IN_PROGRESS, inProgress: inProgress})
    }
}

export const loadZoom = () => {
    
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        const state = getState();

        const userId = state.user.userData.platformID;

        const zoomRequest = {
            method: 'GET',
            uri: `${API_BASE_URL}/zoom/account?userId=${userId}`,
            json: true
        }
        rp(zoomRequest)
            .then( response => {

                const account_exists = response.success;
                dispatch({type: SET_ZOOM_CONNECTED, connected: account_exists})
            })
            .catch( err => {
                dispatch({type: SET_ZOOM_CONNECTED, connected: false})
            })
    }
}

export const loadClasses = () => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        const state = getState();

        
        const userId = state.user.userData.platformID;
        if (userId == null) {
            console.log("couldn't find it...")
            return;
        }
        const firestore = getFirestore();
        console.log("fetching classes")
        return firestore.collection("classes").where("deleted", "==", false).where("instructor_id", "==", userId).where("start_time", ">=", moment().unix()).get()
            .then(snapshot => {
                const classes = snapshotToObjects(snapshot);
                console.log("got some classes")
                console.log(classes.length)
                dispatch({type: 'SET_SCHEDULED_CLASSES', classes: classes})
                return classes
            })
    }
}

export const loadInstructors = () => {

    return (dispatch, getState, { getFirebase, getFirestore }) => {
        const state = getState();

        const userId = state.user.userData.platformID;

        if (userId == null) {
            // setTimeout(() => {
            //     return loadServices();    
            // }, 1000);
            return;
        }

        apiRequest(`connections/get?partnerId=${userId}`)
            .then(response => {
                if (response?.connections) {
                    const resultConnections = response.connections.map(val => {
                        return {
                            ...val,
                            status: val.verified ? "connected" : "pending"
                        }
                    }).filter(val => {
                        return val.verified
                    })
                    dispatch({type: SET_CONNECTED_ACCOUNTS, connectedAccounts: resultConnections})
                    // console.log(resultConnections)
                    // setConnections(resultConnections)
                }
                // dispatch({type: SET_CONNECTED_ACCOUNTS, connectedAccounts: response})
            })
            .catch(err => {
                console.log("couldn't find connected eaccounts", err)
            })
    }

}

export const loadServices = () => {

    return (dispatch, getState, { getFirebase, getFirestore }) => {

        const state = getState();

        const userId = state.user.userData.platformID;

        if (userId == null) {
            // setTimeout(() => {
            //     return loadServices();    
            // }, 1000);
            return;
        }

        const firestore = getFirestore();

        return firestore.collection('users').doc(userId).collection('services').get()
            .then(snapshot => {
                const services = snapshotToObjects(snapshot).filter(val => {
                    return !val.deleted;
                })
                dispatch({type: 'SET_SERVICES', services })
                return services;
            })
            .catch( err => {
                console.log(err)
                dispatch({type: 'SET_SERVICES', services: [] })
                return [];
            })

        const theseServices = [
            {
                name: "This",
                location_type: 'live'
            },
            {
                name: "That",
                location_type: 'live'
            },
            {
                name: "Other",
                location_type: 'on-demand'
            },
            {
                name: "Thing",
                location_type: 'live'
            },
        ]

        dispatch({type: 'SET_SERVICES', services: theseServices })
    }
};

function saveServicesPhotos(files, userId) {
    console.log('saveServicesPhotos')

    return dispatch => {
        if (files.length < 1) {
            return Promise.resolve([])
        }
        const storage = firebase.storage();

        return Promise.all(files.map(val => {
            var ref = storage.ref();
            ref = ref.child(`users/${userId}/services/${Date.now()}-${files[0].name}`)
            return ref.put(val);
        })).then(snapshots => {
            return Promise.all(snapshots.map(snap => {
                return snap.ref.getDownloadURL()
            }))
        }).then(downloadUrls => {
            return downloadUrls
        })
    }
}

// class_times
// desc: time_string,
// start_time: moment_start.unix(),
// end_time: moment_end.unix(),
// duration: duration
// {
//     "existing_service_type": "Create New...",
//     "service": {
    //   "experience_type": "class",
    //   "name": "New workout",
    //   "location_type": "",
    //   "purchase_type": "Paid",
    //   "description": "Yoga meets triathlon",
    //   "price": "10",
    //   "minimum_price": 0,
    //   "workout_types": [
    //     "Yoga"
    //   ],
    //   "body_focus": "Total Body",
    //   "intensity": "Beginner",
    //   "equipment_required": [],
    //   "max_capacity": 999,
    //   "file1": {},
    //   "file2": null,
    //   "file3": null,
    //   "images": [],
    //   "preview_url": ""
//     },
//     "hosted_by": "You!",
//     "meet_time": "Weekly",
//     "start_date": "Sat Aug 1, 2020",
//     "end_date": "Tue Sep 1, 2020",
//     "days_of_the_week": [
//       "Saturday",
//       "Monday"
//     ],
//     "start_time": "8:32 PM",
//     "end_time": "9:32 PM",
//     "location_name": "instagram",
//     "instagram_handle": "thebalancedtriathlete",
//     "zoom_link": "",
//     "youtube_link": "",
//     "other_link": ""
//   }

export function deleteService(service) {

    return (dispatch, getState, { getFirebase, getFirestore }) => {
        const state = getState()

        const userData = state.user.userData;
        const instructor_id = userData.platformID;

        service.created = Math.floor(Date.now() / 1000);

        return db.collection('users').doc(instructor_id).collection('services').doc(service.id)
            .set({
                deleted: true
            }, {merge: true})
            .then( ref => {
                return dispatch({type: DELETE_SERVICE, service: service})
            })
    }
}

function saveNewService(service, userId) {

    return dispatch => {

        service.created = Math.floor(Date.now() / 1000);

        return db.collection('users').doc(userId).collection('services')
            .add(service)
            .then( ref => {
                service.platformID = ref.id;
                return service;
            })
    }
}

function updateService(service, userId, serviceId) {
    return dispatch => {
        return db.collection('users').doc(userId).collection('services').doc(serviceId)
            .set(service, { merge: true })
            .then(() => {
                // service.platformID = ref.id;
                return service;
            })
    }
}

function updateClass(classId, service, instructor_id, host_ids, instructor_name, time_object, zoomConnected) {
    return async dispatch => {
        const { start_time,
            // end_time,
            duration } = time_object;
        var new_class = JSON.parse(JSON.stringify(service))
        // new_class.service_id = new_class.platformID
        delete new_class.platformID

        new_class.reserve_link = new_class.content_link ?? "";
        new_class.start_time = start_time;
        // new_class.end_time = end_time;
        new_class.duration = duration;
        new_class.instructor_name = instructor_name;
        new_class.instructor_id = instructor_id;
        new_class.host_name = instructor_name;
        new_class.host_ids = host_ids//[instructor_id];
        if (new_class.description) {
            new_class.class_about = new_class.description
        }
        if (new_class.name) {
            new_class.class_name = new_class.name
        }
        if (!new_class.total_booked) {
            new_class.total_booked = 0;
        }
        new_class.deleted = false;
        new_class.canceled = false;

        console.log("about to update this class")
        console.log(new_class)
        // return true
        // new_class.created = Math.floor(Date.now() / 1000);

        // if (new_class.location_name?.toLowerCase() === "zoom" && new_class.zoom) {
        if (new_class.location_name?.toLowerCase() === "zoom") {
            if (new_class.zoom?.id) { // if this class already has zoom, update it
                try {
                    console.log("updating zoom meeting")
                    const updateZoomResponse = await updateZoomMeeting(new_class)
                    console.log("Zoom response: ", updateZoomResponse)
                    console.log("UPDATE ZOOM RESPONSE: ", updateZoomResponse)
                    new_class.reserve_link = new_class.zoom.join_url
                    new_class.content_link = new_class.zoom.join_url
                } catch (err) {
                    throw err
                }
                
            } else if (zoomConnected) { // if it doens't have zoom yet, create one.. 
                try {
                    const zoom = await createZoomMeeting(new_class)
                    console.log("Zoom response: ", zoom)
                    // console.log(zoom)
                    if (zoom) {
                        new_class.zoom = zoom 
                    }
                    new_class.reserve_link = zoom?.join_url ?? ""
                    new_class.content_link = zoom?.join_url ?? ""
                    
                } catch (err) {
                    throw err
                }

            } 
            // new_class.zoom = zoom
        } else {
            delete new_class.zoom
        }
        

        await db.collection("classes").doc(classId).set(new_class, {merge: true})

        new_class.platformID = classId
        return new_class
    }
}

const updateZoomMeeting = (classObject) => {
    return new Promise((resolve, reject) => {
        classObject.userId = classObject.instructor_id
        classObject.meetingId = classObject.zoom.id
        const zoomRequest = {
            method: 'PUT',
            uri: `${API_BASE_URL}/zoom/meetings`,
            body: classObject,
            json: true
        }
        rp(zoomRequest)
            .then( response => {
                resolve(response)
            })
            .catch( err => {
                reject(err)
            })
    })
}

const deleteZoomMeetingIfNeeded = (classObject) => {
    return new Promise((resolve, reject) => {
        if (!classObject?.zoom?.id) {
            resolve("Success")
            return
        }
        classObject.userId = classObject.instructor_id
        classObject.meetingId = classObject.zoom.id
        const zoomRequest = {
            method: 'DELETE',
            uri: `${API_BASE_URL}/zoom/meetings`,
            body: classObject,
            json: true
        }
        rp(zoomRequest)
            .then( response => {
                resolve("Success")
            })
            .catch( err => {
                reject(err)
            })
    })
}

const createZoomMeeting = (classObject) => {

    return new Promise((resolve, reject) => {
        classObject.userId = classObject.instructor_id
        const zoomRequest = {
            method: 'POST',
            uri: `${API_BASE_URL}/zoom/meetings`,
            body: classObject,
            json: true
        }
        rp(zoomRequest)
            .then( response => {
                resolve(response)
            })
            .catch( err => {
                reject(err)
            })
    })
}

// JARCH
function saveNewClasses(service, instructor_id, host_ids, instructor_name, class_times) {
    return async (dispatch, getState) => {

        const zoomConnected = getState().scheduling.zoomConnected;

        const new_classes_promises = class_times.map(async time => {
            const { start_time,
                // end_time,
                duration } = time;
            var new_class = JSON.parse(JSON.stringify(service))

            new_class.service_id = new_class.platformID;
            delete new_class.platformID;

            if (new_class.content_link) {
                new_class.reserve_link = new_class.content_link
            }
            if (new_class.description) {
                new_class.class_about = new_class.description
            }
            if (new_class.name) {
                new_class.class_name = new_class.name
            }
            new_class.start_time = start_time;
            // new_class.end_time = end_time;
            new_class.duration = duration;
            new_class.instructor_name = instructor_name;
            new_class.instructor_id = instructor_id;
            new_class.host_name = instructor_name;
            new_class.host_ids =  host_ids//[instructor_id];
            new_class.total_booked = 0;
            new_class.deleted = false;
            new_class.canceled = false;
            new_class.created = Math.floor(Date.now() / 1000);

            // JARCH here?
            if (new_class.location_name?.toLowerCase() === "zoom" && zoomConnected) {
                // create zoom link
                // await wait()
                // new_class.waited = true
                try {
                    const zoom = await createZoomMeeting(new_class)
                    if (zoom.code && (zoom.code >= 400 && zoom.code <= 499)) {
                        // something
                        console.log("Zoom response: ", zoom)
                        if (zoom.code === 429) {
                            throw "Zoom limits the amount of classes you can schedule in one day to 100. We recommend you come back at 4 PM Pacific Time and add more links then. We apologize for the inconvenience."
                        }
                        if (zoom.message) {
                            throw zoom.message
                        }
                        throw "There was an error creating Zoom meetings on your behalf. Please contact Sutra support"
                    }
                    console.log("Zoom response: ", zoom)
                    if (zoom) {
                        new_class.zoom = zoom 
                    }
                    new_class.reserve_link = zoom?.join_url ?? ""
                    new_class.content_link = zoom?.join_url ?? ""
                    
                } catch (err) {
                    throw err
                }
                
                
            }
            return new_class
        })

        const new_classes = await Promise.all(new_classes_promises)
        
        // var new_classes = []
        // for (let index = 0; index < class_times.length; index++) {
            
        // }

        // const new_classes = class_times.map(time => {
        //     const { start_time,
        //         end_time,
        //         duration } = time;
        //     var new_class = JSON.parse(JSON.stringify(service))

        //     new_class.service_id = new_class.platformID;
        //     delete new_class.platformID;

        //     new_class.reserve_link = new_class.content_link;
        //     new_class.start_time = start_time;
        //     new_class.end_time = end_time;
        //     new_class.duration = duration;
        //     new_class.instructor_name = instructor_name;
        //     new_class.instructor_id = instructor_id;
        //     new_class.host_name = instructor_name;
        //     new_class.host_ids = [instructor_id];
        //     new_class.total_booked = 0;
        //     new_class.deleted = false;
        //     new_class.canceled = false;
        //     new_class.created = Math.floor(Date.now() / 1000);

        //     // JARCH here?
        //     if (zoomConnected) {
        //         // create zoom link
        //     }
        //     return new_class;
        // })

        console.log("about to upload new class")
        console.log(new_classes.length)
        console.log(new_classes)

        // return Promise.resolve('Success')
        var batch = db.batch()

        new_classes.forEach(val => {
            var new_class_ref = db.collection('classes').doc()
            val.platformID = new_class_ref.id
            batch.set(new_class_ref, val);
        })

        await batch.commit()

        return ["success", new_classes]

        // return Promise.all([batch.commit(), Promise.resolve(new_classes)])
    }
}

// JARCH

export const uploadNewService = (form_data) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        dispatch(uploadInProgress(true))
        const { service } = form_data;

        delete service.location_type
        delete service.content_link
        delete service.reserve_link
        delete service.location
        delete service.location_name
        delete service.location_type

        var files = [];
        if (service.file1) {
            files.push(service.file1);
        }
        if (service.file2) {
            files.push(service.file2);
        }
        if (service.file3) {
            files.push(service.file3);
        }
        delete service.file1;
        delete service.file2;
        delete service.file3;

        const state = getState();

        const userData = state.user.userData;
        const instructor_id = userData.platformID;

        console.log(`saving photos from userId: ${instructor_id}`)
        return dispatch(saveServicesPhotos(files, instructor_id))
            .then( images => {
                console.log(images)
                let copy_service = JSON.parse(JSON.stringify(service));
                copy_service.images = images;
                return dispatch(saveNewService(copy_service, instructor_id));
            })
            .then(new_service => {
                dispatch({type: ADD_SERVICE, service: new_service})
                dispatch(uploadInProgress(false))
                return {success: true, message: "Service uploaded"}
            })
            .catch(err => {
                console.log("Error uploading classes")
                console.log(err)
                dispatch(uploadInProgress(false))
                return {success: false, message: `There seems to have been an error uploading this service. Please see the error below and try again: ${err}`}
            })
    };
}
export const uploadNewServiceWithClasses = (form_data, class_times) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        dispatch(uploadInProgress(true))
        const { service } = form_data;

        var files = [];
        if (service.file1) {
            files.push(service.file1);
        }
        if (service.file2) {
            files.push(service.file2);
        }
        if (service.file3) {
            files.push(service.file3);
        }
        delete service.file1;
        delete service.file2;
        delete service.file3;

        const state = getState();

        const userData = state.user.userData;
        const instructor_id = userData.platformID;
        var instructor_name = userData.firstName;

        // const host_id = form_data.hosted_by
        // const hostData = form_data.hostData
        // if (hostData) {
        //     instructor_name = hostData?.instructorProfile?.partnerName ?? hostData.firstName
        // }
        const host_ids = form_data.hosted_by
        // .map(val => val.id)
        const hostData = form_data.hostData
        if (hostData) {
            const host_names = hostData.map(val => {
                return val?.instructorProfile?.partnerName ?? val.firstName
            })
            instructor_name = host_names.join(' & ')
            // instructor_name = hostData?.instructorProfile?.partnerName ?? hostData.firstName
        }

        console.log(`saving photos from userId: ${instructor_id}`)
        return dispatch(saveServicesPhotos(files, instructor_id))
            .then( images => {
                console.log(images)
                let copy_service = JSON.parse(JSON.stringify(service));
                copy_service.images = images;
                return dispatch(saveNewService(copy_service, instructor_id));
            })
            .then(new_service => {
                dispatch({type: ADD_SERVICE, service: new_service})
                return dispatch(saveNewClasses(new_service, instructor_id, host_ids, instructor_name, class_times))
            })
            .then(([response, newClasses]) => {
                console.log("uploaded classes")
                console.log(response)
                dispatch({type: ADD_SCHEDULED_CLASSES, classes: newClasses})
                dispatch(uploadInProgress(false))
                return {success: true, message: "Classes uploaded"}
            })
            .catch(err => {
                console.log("Error uploading classes")
                console.log(err)
                dispatch(uploadInProgress(false))
                return {success: false, message: `There seems to have been an error uploading this class. Please see the error below and try again: ${err}`}
            })
    };
}

export const uploadDuplicateService = (form_data) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        dispatch(uploadInProgress(true))

        const { service } = form_data;

        const { platformID } = service;

        if (!platformID) {
            dispatch(uploadInProgress(false))
            return Promise.resolve({success: false, message: "Unable to Duplicate this service. Please refresh and try again."})
        }

        var files = [];
        if (service.file1) {
            files.push(service.file1);
        }
        if (service.file2) {
            files.push(service.file2);
        }
        if (service.file3) {
            files.push(service.file3);
        }
        delete service.file1;
        delete service.file2;
        delete service.file3;

        const state = getState();

        const userData = state.user.userData;
        const instructor_id = userData.platformID;
        // const instructor_name = userData.firstName;

        console.log("Files: ", files)
        return dispatch(saveServicesPhotos(files, instructor_id))
            .then( images => {
                console.log(images)
                let copy_service = JSON.parse(JSON.stringify(service));
                copy_service.images = images;
                return dispatch(saveNewService(copy_service, instructor_id));
            })
            .then(response => {
                console.log("duplicated service")
                console.log(response)
                dispatch(uploadInProgress(false))
                return {success: true, message: "Service Duplicated with new data"}
            })
            .catch(err => {
                console.log("Error uploading classes")
                console.log(err)
                dispatch(uploadInProgress(false))
                return {success: false, message: `There seems to have been an uploading this new service. Please see the error below and try again: ${err}`}
            })
    }
}

// JARCH
export const updateExistingClass = (classId, form_data, time_object) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        dispatch(uploadInProgress(true))
        const { service } = form_data;
        // const { platformID } = service;
        const zoomConnected = getState().scheduling.zoomConnected;

        if (!classId) {
            dispatch(uploadInProgress(false))
            return Promise.resolve({success: false, message: "Unable to update this service. Please refresh and try again."})
        }

        var files = [];
        if (service.file1) {
            files.push(service.file1);
        }
        if (service.file2) {
            files.push(service.file2);
        }
        if (service.file3) {
            files.push(service.file3);
        }
        delete service.file1;
        delete service.file2;
        delete service.file3;

        const state = getState();

        const userData = state.user.userData;
        const instructor_id = userData.platformID;
        var instructor_name = userData.firstName;

        const host_ids = form_data.hosted_by
        // .map(val => val.id)
        const hostData = form_data.hostData
        if (hostData) {
            const host_names = hostData.map(val => {
                return val?.instructorProfile?.partnerName ?? val.firstName
            })
            instructor_name = host_names.join(' & ')
            // instructor_name = hostData?.instructorProfile?.partnerName ?? hostData.firstName
        }

        console.log("Files: ", files)
        return dispatch(saveServicesPhotos(files, instructor_id))
            .then( images => {
                console.log(images)
                let copy_service = JSON.parse(JSON.stringify(service));
                if (images.length > 0) {
                    copy_service.images = images;
                }
                return dispatch(updateClass(classId, copy_service, instructor_id, host_ids, instructor_name, time_object, zoomConnected))
                // return UPDATE CLASS
                // return dispatch(updateService(copy_service, instructor_id, platformID));
            })
            .then(updatedClass => {
                console.log("updated class")
                console.log(updatedClass)
                dispatch({type: UPDATE_SCHEDULED_CLASS, class: updatedClass})

                dispatch(uploadInProgress(false))
                return {success: true, message: "Class Updated"}
            })
            .catch(err => {
                console.log("Error Updating Class")
                console.log(err)
                dispatch(uploadInProgress(false))
                return {success: false, message: `There seems to have been an error updating this class. Please see the error below and try again: ${err}`}
            })

    }
}

export const updateExistingService = (form_data) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        dispatch(uploadInProgress(true))

        const { service } = form_data;

        delete service.location_type
        delete service.content_link
        delete service.reserve_link
        delete service.location
        delete service.location_name
        delete service.location_type

        const { platformID } = service;

        if (!platformID) {
            dispatch(uploadInProgress(false))
            return Promise.resolve({success: false, message: "Unable to update this service. Please refresh and try again."})
        }

        var files = [];
        if (service.file1) {
            files.push(service.file1);
        }
        if (service.file2) {
            files.push(service.file2);
        }
        if (service.file3) {
            files.push(service.file3);
        }
        delete service.file1;
        delete service.file2;
        delete service.file3;

        const state = getState();

        const userData = state.user.userData;
        const instructor_id = userData.platformID;
        // const instructor_name = userData.firstName;

        console.log("Files: ", files)
        return dispatch(saveServicesPhotos(files, instructor_id))
            .then( images => {
                console.log(images)
                let copy_service = JSON.parse(JSON.stringify(service));
                if (images.length > 0) {
                    copy_service.images = images;
                }
                return dispatch(updateService(copy_service, instructor_id, platformID));
            })
            .then(response => {
                console.log("updated service")
                console.log(response)
                dispatch(uploadInProgress(false))
                dispatch({type: UPDATE_SERVICE, service: response})
                return {success: true, message: "Service Updated"}
            })
            .catch(err => {
                console.log("Error Updating Service")
                console.log(err)
                dispatch(uploadInProgress(false))
                return {success: false, message: `There seems to have been an error updating this service type. Please see the error below and try again: ${err}`}
            })
    }
}

export const canceledReservationForClass = (classData) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {

        console.log("Canceling for this class: ", classData)
        const updatedClass = {
            ...classData,
            total_booked: classData.total_booked - 1
        }
        dispatch({type: UPDATE_SCHEDULED_CLASS, class: updatedClass})
    };
}

export const canceledReservationForClassId = (classId) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {

        // console.log("Canceling for this class: ", classData)
        const classes = getState().instructor.classes

        const index = classes.findIndex(val => val.id === classId)

        if (index !== -1) {
            const copiedClass = {
                ...classes[index]
            }

            const updatedClass = {
                ...copiedClass,
                total_booked: copiedClass.total_booked - 1
            }
            dispatch({type: UPDATE_SCHEDULED_CLASS, class: updatedClass})
        }
    };
}

export const addedReservationForClassId = (classId) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {

        // console.log("Canceling for this class: ", classData)
        const classes = getState().instructor.classes

        const index = classes.findIndex(val => val.id === classId)

        if (index !== -1) {
            const copiedClass = {
                ...classes[index]
            }

            const updatedClass = {
                ...copiedClass,
                total_booked: copiedClass.total_booked + 1
            }
            dispatch({type: UPDATE_SCHEDULED_CLASS, class: updatedClass})
        }
    };
}


// JARCH
export const uploadNewClasses = (form_data, class_times) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {

        console.log("uploading: ", form_data)
        dispatch(uploadInProgress(true))
        const { service } = form_data;
        const { platformID } = service;

        var files = [];
        if (service.file1) {
            files.push(service.file1);
        }
        if (service.file2) {
            files.push(service.file2);
        }
        if (service.file3) {
            files.push(service.file3);
        }
        delete service.file1;
        delete service.file2;
        delete service.file3;

        const state = getState();

        const userData = state.user.userData;
        const instructor_id = userData.platformID;
        var instructor_name = userData.firstName;

        // const host_id = form_data.hosted_by
        // const hostData = form_data.hostData
        // if (hostData) {
        //     instructor_name = hostData.firstName ?? hostData.instructorProfile?.partnerName
        // }
        const host_ids = form_data.hosted_by
        // .map(val => val.id)
        const hostData = form_data.hostData
        if (hostData) {
            const host_names = hostData.map(val => {
                return val?.instructorProfile?.partnerName ?? val.firstName
            })
            instructor_name = host_names.join(' & ')
            // instructor_name = hostData?.instructorProfile?.partnerName ?? hostData.firstName
        }

        console.log("Files: ", files)
        return dispatch(saveServicesPhotos(files, instructor_id))
            .then( images => {
                console.log(images)
                let copy_service = JSON.parse(JSON.stringify(service));
                if (images.length > 0) {
                    copy_service.images = images;
                }
                // return dispatch(updateService(copy_service, instructor_id, platformID));
                return copy_service
            }).then(service => {
                return dispatch(saveNewClasses(service, instructor_id, host_ids, instructor_name, class_times))
            })
            .then(([response, newClasses]) => {
                console.log("uploaded classes")
                console.log(response)
                dispatch({type: ADD_SCHEDULED_CLASSES, classes: newClasses})
                dispatch(uploadInProgress(false))
                return {success: true, message: "Classes uploaded"}
            })
            .catch(err => {
                console.log("Error uploading classes")
                console.log(err)
                dispatch(uploadInProgress(false))
                return {success: false, message: `There seems to have been an error uploading this class. Please see the error below and try again: ${err}`}
            })
    };
}

